<div class="popover-close d-flex" [class.one-product]="(productsCountInPopover$ | async) === 1">
  <button mat-icon-button class="popover-close-button" [disableRipple]="true" [disabled]="showSpinnerPopover">
    <mat-icon class="popover-close-button-icon">close</mat-icon>
  </button>
</div>
<ng-container *ngFor="let product of products$ | async; let productIndex = index">
  <div #popoverProductListing class="product" [id]="product?.bomItemNo" *ngIf="isActive(product?.bomItemNo)">
    <div class="product-details">
      <span class="sku mr-1">{{ product?.code }}</span>
      <ng-container [ngSwitch]="checkStockLevel(product.stock?.stockLevel, product.stock?.stockLevelStatus)">
        <span class="in-stock" *ngSwitchCase="'inStock'">{{ 'product.inStock' | cxTranslate }}</span>
        <span class="no-stock" *ngSwitchCase="'outOfStock'">{{ 'product.noStock' | cxTranslate }}</span>
        <span class="discontinued" *ngSwitchCase="'discontinued'">{{ 'product.discontinued' | cxTranslate }}</span>
      </ng-container>
      <span class="text-truncate name" [title]="product?.name">{{ product?.name }}</span>
    </div>
    <div class="line-break"></div>
  </div>
  <div *ngIf="isActive(product?.bomItemNo)">
    <ng-container
      [ngTemplateOutlet]="productDetailsMore"
      [ngTemplateOutletContext]="{ product: product }"
    ></ng-container>
  </div>
</ng-container>
<ng-template #productDetailsMore let-product="product">
  <div class="product-details-more">
    <div
      class="prices"
      [ngClass]="activeLanguage$ | async"
      [class.gst-labels-on]="(showGstInclusive$ | async) || (showGstExclusive$ | async)"
    >
      <div class="srpPrice">
        <span>{{ 'product.productList.srp' | cxTranslate }}</span>
        <span>{{ getSrpPrice(product?.code) | async }}</span>
        <span class="gst-label" *ngIf="(getSrpPrice(product?.code) | async) && showGstInclusive$ | async">{{
          'gst.inclusive' | cxTranslate
        }}</span>
      </div>
      <ng-container *ngIf="!showSrpOnly">
        <div *ngIf="!basepriceHiddens" class="basePrice">
          <span>{{ 'product.productList.basePrice' | cxTranslate }}</span>
          <span>{{ getBasePrice(product?.code) | async }}</span>
          <span class="gst-label" *ngIf="(getBasePrice(product?.code) | async) && showGstExclusive$ | async">{{
            'gst.exclusive' | cxTranslate
          }}</span>
        </div>
        <div class="dealerPrice">
          <span>{{ 'product.productList.dealerPrice' | cxTranslate }}</span>
          <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(product?.code); else dealerPriceReady">
            <div class="spinner-shimano ev" *ngIf="this.hasDealerPrice">
              <div></div>
            </div>
            <span class="no-dealer-price no-dealer-price-ev" *ngIf="!this.hasDealerPrice"></span>
          </div>
          <ng-template #dealerPriceReady>
            <span>{{ getDealerPrice(product?.code) | async }}</span>
            <span class="gst-label" *ngIf="dealerPrice(product?.code) && showGstExclusive$ | async">{{
              'gst.exclusive' | cxTranslate
            }}</span>
          </ng-template>
        </div>
      </ng-container>
    </div>
    <div class="actions">
      <div class="pdp">
        <ng-container *ngIf="isDesktop; else pdpNonDesktopTempl">
          <button
            mat-icon-button
            class="assignment rounded-0"
            [disableRipple]="true"
            matTooltip="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
            [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
            attr.aria-label="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
            [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
            *ngIf="product && !isPlpPopupEnabled"
          >
            <mat-icon>assignment</mat-icon>
          </button>
          <div *ngIf="isPlpPopupEnabled" [ngTemplateOutlet]="detailsButton"></div>
        </ng-container>
        <ng-template #detailsButton>
          <div class="details-button-pdp">
            <button
              class="details-button secondary-btn btn-block btn"
              type="button"
              matTooltip="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
              [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
              attr.aria-label="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
              [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
            >
              {{ 'buttonTooltip.plp.pdpDetailsButton' | cxTranslate }}
            </button>
          </div>
        </ng-template>
        <ng-template #pdpNonDesktopTempl>
          <button
            mat-icon-button
            class="assignment rounded-0"
            [disableRipple]="true"
            attr.aria-label="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
            [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
            *ngIf="product && !isPlpPopupEnabled"
          >
            <mat-icon>assignment</mat-icon>
          </button>
          <div *ngIf="isPlpPopupEnabled" [ngTemplateOutlet]="detailsButton"></div>
        </ng-template>
      </div>
      <div class="add-to-cart" [formGroup]="explodedViewFormGroup" *ngIf="product">
        <div class="quantity">
          <fieldset
            [disabled]="
              (isOutOfStock(product?.code) | async) || !(getDealerPrice(product?.code) | async)?.toString().length
            "
          >
            <input
              #quantityInput
              class="form-control"
              type="number"
              min="0"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); this.value = this.value.replace(/^[0]+/g,'')"
              maxlength="3"
              [formControlName]="product?.code"
              (change)="checkInput($event, product?.code)"
            />
          </fieldset>
        </div>
        <ng-container *ngIf="isDesktop; else addToCartNonDesktopTempl">
          <button
            mat-icon-button
            [ngClass]="'sku-' + [product.code]"
            class="add-to-cart-primary rounded-0"
            [disableRipple]="true"
            matTooltip="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
            [matTooltipDisabled]="!deviceDetectorService.isDesktop()"
            attr.aria-label="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
            (click)="backorderCartCheck(product)"
            [disabled]="
              !quantityInput.value ||
              (isOutOfStock(product?.code) | async) ||
              !(getDealerPrice(product?.code) | async)?.toString().length ||
              showSpinnerPopover
            "
          >
            <mat-icon svgIcon="add-to-cart-primary" [inline]="true"></mat-icon>
          </button>
        </ng-container>
        <ng-template #addToCartNonDesktopTempl>
          <button
            mat-icon-button
            [ngClass]="'sku-' + [product.code]"
            class="add-to-cart-primary rounded-0"
            [disableRipple]="true"
            attr.aria-label="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
            (click)="backorderCartCheck(product)"
            [disabled]="
              !quantityInput.value ||
              (isOutOfStock(product?.code) | async) ||
              !(getDealerPrice(product?.code) | async)?.toString().length ||
              showSpinnerPopover
            "
          >
            <mat-icon svgIcon="add-to-cart-primary" [inline]="true"></mat-icon>
          </button>
        </ng-template>
      </div>
    </div>
  </div>
</ng-template>
